import FastClick from 'fastclick';

function includeFastclick() {
  if ('addEventListener' in document) {
    document.addEventListener('DOMContentLoaded', function () {
      FastClick.attach(document.body);
    }, false);
  }
}

// 解决 IOS 11以上系统引入fastclick 出现input 无法获取焦点的问题. IOS 11 以上已经没有 300ms 的延迟了, 引入fastclick会出现 bug.
export default function () {

  var str = navigator.userAgent.toLowerCase();
  var ver = str.match(/cpu iphone os (.*?) like mac os/);
  if (!ver) {//非IOS系统
    // 引入fastclick文件
    includeFastclick();
  } else {
    console.log("你当前的Ios系统版本为：" + ver[1].replace(/_/g, "."));
    if (window.parseInt(ver[1]) >= 11) {
      //不必引入fastclick文件
    } else {
      // 引入fastclick文件
      includeFastclick();
    }
  }
}



// WEBPACK FOOTER //
// ./src/fastclick.js